import graphql__c6a73ddbc613bec5a224 from "./__generated__/ContributionsDatavizViewerFilters_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../../Intl/Context";
import BookmarkedFilter from "../../../Filters/BookmarkedFilter";
import MineFilter from "../../../Filters/MineFilter";

const ContributionsDatavizViewerFilters = props => {
  const participativeModule = useFragment(
    ContributionsDatavizViewerFilters_participativeModule,
    props.participativeModule
  );

  const t = useFormatMessage();
  const filterByLabel = t(intlMessages.filterBy);

  return (
    <div>
      <h3 className="text-bolder d-block margin-bottom-xs">{filterByLabel}</h3>

      <BookmarkedFilter
        participativeModule={participativeModule}
        className="margin-bottom-xxs"
      />

      <MineFilter />
    </div>
  );
};

const ContributionsDatavizViewerFilters_participativeModule = graphql__c6a73ddbc613bec5a224;

export default ContributionsDatavizViewerFilters;

const intlMessages = defineMessages({
  filterBy: {
    id: "participativeModule.contributionsDataviz.viewerFilters.filterBy",
    defaultMessage: "Autres filtres"
  }
});
